// @flow
import * as React from 'react';
import classNames from 'classnames/bind';
import cs from './styles.pcss';

const cx = classNames.bind(cs);

type Props = {
  className?: string,
};

function ClockLoader({ className }: Props): React.Element<'div'> {
  return (
    <div className={cx('clockLoader', className)}>
      <div className={cx('hand', 'hour')} />
      <div className={cx('hand', 'minute')} />
    </div>
  );
}

export default ClockLoader;
